export enum ROLE_USER_PROFILE {
  // PREDIK = 'PREDIK',
  ADMIN = 'ADMIN',
  DIRECTION = 'DIRECTION',
  COMPTABILITE = 'COMPTABILITE',
  ACHAT = 'ACHAT',
  MAINTENANCE = 'MAINTENANCE',
  BILL = 'VALIDATEUR',
}
